// Campus photo for /colleges/dartmouth-college: CC BY 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADartmouth_Hall_at_Dartmouth_College.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/dartmouth-college/; credited under the photo.
const photo = {
    "slug": "dartmouth-college",
    "alt": "Dartmouth Hall, a white three story building with a clock cupola, at Dartmouth College in Hanover, New Hampshire",
    "src": "/colleges/dartmouth-college/campus-1600.webp",
    "srcSmall": "/colleges/dartmouth-college/campus-800.webp",
    "srcMid": "/colleges/dartmouth-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/dartmouth-college/og.jpg",
    "title": "Dartmouth Hall at Dartmouth College",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADartmouth_Hall_at_Dartmouth_College.jpg",
    "read": "2026-10-02"
};

export default photo;
